import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileCallBar } from './components/MobileCallBar';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { ServiceArea } from './pages/ServiceArea';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { Specials } from './pages/Specials';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wjgtppzkg9k4">
      <ScrollToTop data-id="element-1" data-mp="2wj8cxn0bok3n" />
      <div className="flex min-h-screen w-full flex-col bg-bone font-sans" data-id="element-2" data-mp="2wip5j08ate3v">
        <Header data-id="element-3" data-mp="28t4m6g88geu2" />
        <main className="flex-1" data-id="element-4" data-mp="28sur4e8bzhhi">
          <Routes data-id="element-5" data-mp="23vchsmqej08z">
            <Route path="/" element={<Home data-id="element-7" data-mp="23ujkecdc1n3i" />} data-id="element-6" data-mp="23vuoyeelqyvo" />
            <Route path="/services" element={<Services data-id="element-9" data-mp="3ijxsv0nzqion" />} data-id="element-8" data-mp="23v2tr4ox335x" />
            <Route path="/services/:slug" element={<ServiceDetail data-id="element-11" data-mp="3ijpdn24eb1aa" />} data-id="element-10" data-mp="3ikqwvtvkeu33" />
            <Route path="/service-area" element={<ServiceArea data-id="element-13" data-mp="3mkhou0wtvg97" />} data-id="element-12" data-mp="3mlawr57iwbsx" />
            <Route path="/about" element={<About data-id="element-15" data-mp="3rcj6618urx63" />} data-id="element-14" data-mp="3mjg9vlcoy9m7" />
            <Route path="/contact" element={<Contact data-id="element-17" data-mp="3rcsulke91w9o" />} data-id="element-16" data-mp="3rbznujfaj6rj" />
            <Route path="/specials" element={<Specials data-id="element-19" data-mp="6htjo98ovic" />} data-id="element-18" data-mp="3relw6la09qat" />
            <Route path="/privacy" element={<Privacy data-id="element-21" data-mp="7su7f7e1n58" />} data-id="element-20" data-mp="4n7g6m8exco" />
            <Route path="*" element={<NotFound data-id="element-23" data-mp="2zm4zaoz9bl3x" />} data-id="element-22" data-mp="2zld4hgdhhrep" />
          </Routes>
        </main>
        <Footer data-id="element-24" data-mp="33mow1rfx4mpj" />
        <MobileCallBar data-id="element-25" data-mp="33m5a7zn5de68" />
      </div>
    </BrowserRouter>;
}